module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.b21da07c.woff2";